<template>
  <div id="app" :class="isPrerender ? 'blockScroll shimmer' : ''">
    <div :class="isPrerender ? 'shimmer-background' : ''"></div>
    <h1 style="display: none;">
      {{ $t('pages.meta.' + $route.name + '.description').includes('pages.meta') ? $t('pages.meta.index.description') : $t('pages.meta.' + $route.name + '.description') }}
    </h1>
    <h2 style="display: none;">
      Bluuu ช่วยให้คุณจองแม่บ้านคุณภาพดีได้ออนไลน์ในราคาสมเหตุสมผล
      Bluuu lets you book high quality maids online at a reasonable price
    </h2>
    <header>
      <nav-bar />
    </header>
    <main>
      <LoadingSpinner 
        class="container-content card-container translateYg text-center" 
        style="min-height: 50vh" 
        v-if="$store.state.isLoading" 
        :text="$store.state.Loading.text" 
        :cancel="$store.state.Loading.cancel"
        @onCancel="$store.commit('setIsLoading', false)"
      />
      <router-view v-show="!$store.state.isLoading"  />
    </main>
    <footer>
      <b-footer />
    </footer>
    <maid-modal />
    <notifications position="top right" />
    <ImageViewer />
    <sign-in-modal></sign-in-modal>
    <floating-announcement v-if="!isPrerender" />
    <BaseModal id="alert-network-error">
      <div class="text-center">
        <p>{{ $t('error.network_error') }}</p>
      </div>
    </BaseModal>
    <BaseModal id="alert-message-modal" size="sm" @close="onAlertClosed">
      <div class="text-center">
        <p class="alert-message">{{ alertMessage }}</p>
        <b-button variant="primary" class="px-5" @click="hideAlert">
          {{ okText }}
        </b-button>
      </div>
    </BaseModal>
  </div>
</template>

<script>
import NavBar from "./components/NavBar";
import BFooter from "./components/Footer";
import MaidModal from "./components/Modal/MaidDetail";
import SignInModal from "./components/Modal/SignInModal";
import ImageViewer from "./components/ImageViewer";
import LoadingSpinner from "./components/LoadingSpinner";
import BaseModal from './components/Modal/BaseModal'
import FloatingAnnouncement from '@/components/FloatingAnnouncement.vue'

export default {
  data() {
    return {
      isMounted: false,
      isMaintain: window.location.search.substr(1),
      isPrerender : ( window.__prerender && window.__prerender.prerendering ) || false,
      alertMessage: '',
    }
  },
  components: { NavBar, BFooter, MaidModal, ImageViewer, SignInModal, LoadingSpinner, BaseModal, FloatingAnnouncement },
  computed: {
    okText() {
      if (this.$te && this.$te('button.ok')) return this.$t('button.ok')
      return this.$i18n.locale === 'th' ? 'ตกลง' : 'OK'
    },
    fallbackAlertText() {
      return this.$i18n.locale === 'th'
        ? 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง'
        : 'Something went wrong. Please try again.'
    },
  },
  // computed: {
  //   blockScroll() {
  //     return this.$store.state.blockScroll;
  //   },
  // },
  created() {
    this.nativeAlert = window.alert
    // ให้ alert() ทุกที่ในแอปเด้ง BaseModal แทน popup ของเบราว์เซอร์
    window.alert = (...args) => this.showAlert(args.length > 1 ? args : args[0])
  },
  beforeDestroy() {
    if (this.nativeAlert) window.alert = this.nativeAlert
  },
  methods: {
    showAlert(message) {
      const text = this.normalizeAlertMessage(message)
      this.alertMessage = text || this.fallbackAlertText
      this.$nextTick(() => {
        this.$root.$emit('bv::show::modal', 'alert-message-modal')
      })
    },
    hideAlert() {
      this.$root.$emit('bv::hide::modal', 'alert-message-modal')
    },
    onAlertClosed() {
      this.alertMessage = ''
    },

    sanitizeAlertText(text) {
      if (typeof text !== 'string') return ''
      const cleaned = text
        .replace(/\[object [A-Za-z]*\]/g, '')
        .replace(/[ \t]{2,}/g, ' ')
        .replace(/^[\s:;,._-]+|[\s:;,._-]+$/g, '')
        .trim()
      return cleaned
    },

    normalizeAlertMessage(message, depth = 0) {
      if (message === null || message === undefined) return ''
      if (typeof message === 'string') return this.sanitizeAlertText(message)
      if (typeof message === 'number' || typeof message === 'boolean') return String(message)
      if (typeof message === 'function' || typeof message === 'symbol') return ''
      if (depth > 4) return ''

      if (Array.isArray(message)) {
        return message
          .map((item) => this.normalizeAlertMessage(item, depth + 1))
          .filter((text) => !!text)
          .join('\n')
      }

      if (typeof message !== 'object') return String(message)

      if (message instanceof Error) {
        return this.sanitizeAlertText(message.message || message.name || '')
      }

      const responseData = message.response && message.response.data
      const candidates = [
        responseData && responseData.message,
        responseData && responseData.error,
        responseData && responseData.errors,
        message.message,
        message.error,
        message.error_description,
        message.description,
        message.detail,
        message.msg,
        message.text,
      ]

      for (const candidate of candidates) {
        const text = this.normalizeAlertMessage(candidate, depth + 1)
        if (text) return text
      }

      try {
        const json = JSON.stringify(message)
        if (json && json !== '{}' && json !== '[]') return this.sanitizeAlertText(json)
      } catch (e) {
        // circular structure — ปล่อยไปใช้ fallback
      }

      return ''
    },
  },
  async mounted() {
    if(this.isPrerender){
      this.$nextTick(() => {
        setTimeout(() => {
          document.dispatchEvent(new Event("render-done"));
        }, 1000*25);
      })
    } else {
      if (!this.$route.path.startsWith('/en') && !this.$route.path.startsWith('/th') && !(this.$route.path == '/')) {
        this.$router.push('/' + this.$i18n.locale + this.$route.fullPath)
      }
      if (!this.isMounted) {
        let g = location.href + "?openExternalBrowser=1";
        console.log("window::::", g);
  
        let UA = navigator.userAgent || navigator.vendor || window.opera;
  
        let isLINE = function (UA) {
          return UA.indexOf("Line/") > -1;
        };
        if (isLINE(UA)) {
          // alert("from Line");
          // window.open(g);
          location.href = g;
        }
        this.isMounted = true;
      }
      console.log("app", window.location.search.substr(1));
    
    }
  },
};
</script>
<style lang="scss" scoped>
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: "Kanit", sans-serif;
}

.alert-message {
  white-space: pre-line;
  word-break: break-word;
  margin-bottom: 1.5rem;
}

.blockScroll {
  overflow: hidden;
  height: 100vh;
  position: relative;
}

.disable-scrolling{
  height: 100%;
  overflow-x: hidden;
}

.shimmer {
  color: grey;
  display:inline-block;
  -webkit-mask:linear-gradient(90deg,#000 30%,#0005,#000 50%) right/300% 100%;
  background-repeat: no-repeat;
  animation: shimmer 2.5s infinite;
}

.shimmer-background {
  opacity: 0.4;
  position: absolute;
  width: 100%;
  height: 100%;
  background: white;
  z-index: 1;
}

@keyframes shimmer {
  100% {-webkit-mask-position:left}
}

</style>